import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { productTypes } from 'actions/types'

const initialState = []
const baseType = productTypes.FETCH_OFFERING_TYPES

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
